import { createLS } from "../../utils/localStorageHelper/createLS";
import { lsEncoded } from "../../utils/localStorageHelper/lsEncoded";
import { IAuthStore } from "./localStoreTypes";

export const localStore = {
    auth: createLS<IAuthStore>(lsEncoded, 'auth'),
}